<template>
    <NxSelectReduced
    :value="localValue"
    :options="listOptions"
    labelText="Situação:"
    id="selectSituacao"
    placeholder="Selecione a(s) Situação(s)"
    :multiple="multiple"
    @update:value="handleValueUpdate"
  ></NxSelectReduced>
</template>
<script>
import { useReactiveModelMixin } from '../../mixins'

export default {
  name: 'NxSelectSituacao',
  mixins: [ useReactiveModelMixin('value') ],
  props: {
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      listOptions: [{
        value: 1,
        text: 'ATIVO'
      },
      {
        value: 2,
        text: 'GANHO'
      },
      {
        value: 0,
        text: 'PERDIDO'
      },
      {
        value: 3,
        text: 'FINALIZADO'
      }],
      selected: null
    }
  },
  methods: {
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectSituacao.vue